import React, { useEffect, useState } from "react";
import PrivilegeAccountListHeader from "../../components/PrivilegeAccounts/PrivilegeAccountListHeader";
import { fetchAllPrivileges } from "../../services/privilegeService";
import { getFormattedPrivilegeList } from "../../helper";
import PrivilegeAccountTable from "../../components/PrivilegeAccounts/PrivilegeAccountsTable";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLoadContext } from "../../contexts/LoadContext";

const PrivilegeAccount = () => {
  const [privilegeAccountData, setPrivilegeAccountData] = useState([]);
  const navigate = useNavigate();
  const { setLoader } = useLoadContext();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await fetchAllPrivileges();
      setPrivilegeAccountData(getFormattedPrivilegeList(res?.data?.data));
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      setLoader(false);
    }
  };
  return (
    <>
      <PrivilegeAccountListHeader />
      <PrivilegeAccountTable
        data={privilegeAccountData}
        isTableDataLoading={false}
        onEdit={(id) => navigate(`/admin/edit-privilege-account/${id}`)}
      />
    </>
  );
};

export default PrivilegeAccount;
